import paymentApi from '../../../payment-api'

export const setPrice = (state, prices) => {
  return {
    signUpPrices: prices || undefined
  }
}

export const setInput = (state, input) => {
  return {
    signUpInput: input || {}
  }
}

export const setAddOns = (state, addOns) => {
  return {
    signUpAddOns: addOns || []
  }
}

export const setSuggestion = (state, suggestion) => {
  return {
    signUpSuggestion: suggestion || undefined
  }
}

export const getSignatureCases = async (state) => {
  const data = await paymentApi.get('/customer/signaturecases')
  return {
    signatureCases: data
  }
}

export const getReceipt = async (state, orderId) => {
  const paymentReceipt = await paymentApi.get(`/orders/${orderId}`)

  return {
    paymentReceipt
  }
}



// WEBPACK FOOTER //
// ./components/signup-flow/step-result/actions.js